import React from "react";
import PropTypes from "prop-types";
import { useSubscriptionContext } from "../utils/Contexts/V2/SubscriptionContext";
import Button from "./forms/Button";
import { usePaymentContext } from "../utils/Contexts/V2/PaymentContext";
import { useWalletContext } from "../utils/Contexts/V2/WalletContext";

const benefits = [
  {
    name: "Your Own business website",
    availability: true,
  },
  {
    name: "Review and collection of feedback",
    availability: true,
  },
  {
    name: "1000 SMS text marketing",
    availability: true,
  },
  {
    name: "50 Whatsapp reviews",
    availability: true,
  },
];

function SubscriptionCards({ billingRate, navigateHandler }) {
  const { setPaymentReason, setTopUpAmount } = useWalletContext();
  const { activePlans, selectedPlanHandler, setPaymentSubscriptionData } =
    useSubscriptionContext();
  const { country, currency } = usePaymentContext();

  console.log("billingRate", billingRate);

  console.log(
    "activePlans",
    activePlans
      ?.filter((plan) =>
        plan.name.toLowerCase().includes(billingRate.toLowerCase())
      )
      .sort((a, b) => {
        const priceA = a.price[billingRate]?.Kenya || 0;
        const priceB = b.price[billingRate]?.Kenya || 0;
        return priceA - priceB;
      })
  );
  return (
    <div className="flex flex-col justify-start items-center space-y-10 mt-6 w-full font-sans">
      {/* We only show billing rates if they have pricing for each billingRage
          Eg, users should only see `Web` when they go the annual plans, because that plan is only billed annually
      */}
      {activePlans
        ?.filter((plan) =>
          plan.name.toLowerCase().includes(billingRate.toLowerCase())
        )
        .sort((a, b) => {
          const priceA = a.price[billingRate]?.Kenya || 0;
          const priceB = b.price[billingRate]?.Kenya || 0;
          return priceA - priceB;
        })
        .map((item) => (
          <div
            className="relative pt-10 px-8 pb-8 flex flex-col justify-start items-center space-y-8 w-full rounded-2xl border-[0.019rem] border-[#EAECF0] shadow-lg"
            key={item.id}
          >
            {item.benefits.recommended && (
              <div className="absolute right-0 top-0">
                <svg
                  width="88"
                  height="87"
                  viewBox="0 0 88 87"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M39.5002 0.5H2L87 85V47L39.5002 0.5Z"
                    fill="url(#paint0_linear_2511_15499)"
                    stroke="url(#paint1_linear_2511_15499)"
                  />
                  <path
                    d="M25.1582 9.39979L26.0986 10.3402L28.1422 8.2967L28.7432 8.89775L28.022 12.2636L29.0402 13.2818L29.8039 9.67556C30.5958 10.1423 31.4939 10.2342 32.2858 9.44222L32.3141 9.41393C33.3465 8.38156 33.0212 7.15119 31.9111 6.04103L30.214 4.34398L25.1582 9.39979ZM28.8139 7.62495L30.4261 6.01275L31.1827 6.76935C31.7838 7.37039 31.9464 7.92901 31.3666 8.50884L31.3383 8.53712C30.8009 9.07452 30.1999 9.01088 29.5705 8.38156L28.8139 7.62495ZM29.7917 14.0333L33.0727 17.3142L33.8151 16.5718L31.4746 14.2313L32.9524 12.7534L34.7344 14.5353L35.4415 13.8282L33.6596 12.0463L35.0455 10.6604L37.2658 12.8807L38.0083 12.1382L34.8475 8.97746L29.7917 14.0333ZM35.9946 20.3776C37.1966 21.5797 38.6745 21.8271 40.0392 20.7594L39.12 19.8402C38.3068 20.4554 37.4583 20.3139 36.7582 19.6139C35.8248 18.6805 35.9521 17.4643 37.0906 16.3258L37.1471 16.2693C38.2785 15.1379 39.5513 15.0248 40.4423 15.9157C41.1706 16.644 41.1989 17.3653 40.6332 18.1431L41.5878 19.0977C42.6626 17.7966 42.3444 16.3188 41.1847 15.1591C39.7776 13.752 37.6704 13.7661 36.1501 15.2864L36.0935 15.343C34.5379 16.8986 34.4106 18.7936 35.9946 20.3776ZM42.0984 24.9682C41.1791 24.0489 41.2216 22.663 42.3247 21.5599L42.3812 21.5034C43.4702 20.4144 44.7854 20.273 45.7753 21.2629C46.7653 22.2529 46.5744 23.6035 45.5349 24.6429L45.4783 24.6995C44.3823 25.7955 43.053 25.9228 42.0984 24.9682ZM41.3276 25.7106C42.8621 27.2451 44.9834 27.1461 46.4612 25.6682L46.5178 25.6117C48.0027 24.1267 48.031 22.0195 46.5249 20.5134C45.0258 19.0143 42.8691 19.0497 41.3913 20.5276L41.3347 20.5841C39.8781 22.0408 39.7791 24.1621 41.3276 25.7106ZM44.8522 29.0938L45.7008 29.9423L49.5191 26.124L47.2352 31.4768L47.5392 31.7808L52.8637 29.4686L49.0454 33.287L49.9858 34.2274L55.0416 29.1716L53.7971 27.9271L49.0454 30.0767L51.1667 25.2967L49.908 24.038L44.8522 29.0938ZM51.143 35.3846L51.9915 36.2331L55.8099 32.4147L53.5259 37.7675L53.83 38.0716L59.1545 35.7594L55.3361 39.5777L56.2766 40.5182L61.3324 35.4624L60.0879 34.2179L55.3361 36.3675L57.4575 31.5874L56.1988 30.3288L51.143 35.3846ZM57.4338 41.6753L60.7147 44.9563L61.4572 44.2139L59.1167 41.8733L60.5945 40.3955L62.3764 42.1774L63.0835 41.4703L61.3016 39.6884L62.6876 38.3024L64.9079 40.5228L65.6503 39.7803L62.4896 36.6195L57.4338 41.6753ZM61.5631 45.8047L62.4187 46.6603L66.2937 42.7854L64.6956 48.9372L65.6714 49.913L70.7273 44.8572L69.8717 44.0016L66.2159 47.6574L67.7433 41.8732L66.619 40.7489L61.5631 45.8047ZM68.5148 51.2715L72.0857 47.7006L72.6302 48.2451C73.8181 49.433 73.6555 50.5856 72.5666 51.6746L72.51 51.7311C71.3928 52.8484 70.1977 52.9544 69.0664 51.823L68.5148 51.2715ZM66.8319 51.0735L68.3522 52.5938C70.127 54.3686 72.0292 54.1777 73.4999 52.7069L73.5636 52.6433C75.0344 51.1725 75.1829 49.3128 73.4222 47.5521L71.8877 46.0177L66.8319 51.0735ZM71.8797 56.1213L75.1607 59.4023L75.9032 58.6598L73.5626 56.3193L75.0405 54.8415L76.8224 56.6234L77.5295 55.9163L75.7476 54.1343L77.1335 52.7484L79.3538 54.9687L80.0963 54.2263L76.9355 51.0655L71.8797 56.1213ZM77.692 60.4487L81.2629 56.8778L81.8074 57.4223C82.9953 58.6102 82.8327 59.7628 81.7438 60.8518L81.6872 60.9083C80.57 62.0255 79.3749 62.1316 78.2436 61.0002L77.692 60.4487ZM76.0091 60.2507L77.5294 61.771C79.3042 63.5458 81.2064 63.3549 82.6771 61.8841L82.7408 61.8205C84.2116 60.3497 84.36 58.49 82.5994 56.7293L81.0649 55.1949L76.0091 60.2507Z"
                    fill="white"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_2511_15499"
                      x1="1.99988"
                      y1="42.7502"
                      x2="87.0008"
                      y2="42.7502"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#FFAD03" />
                      <stop offset="0.65098" stopColor="#FE8005" />
                      <stop offset="1" stopColor="#FD5308" />
                    </linearGradient>
                    <linearGradient
                      id="paint1_linear_2511_15499"
                      x1="1.99988"
                      y1="42.7502"
                      x2="87.0008"
                      y2="42.7502"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#FFAD03" />
                      <stop offset="0.65098" stopColor="#FE8005" />
                      <stop offset="1" stopColor="#FD5308" />
                    </linearGradient>
                  </defs>
                </svg>
              </div>
            )}
            <div className="flex flex-col items-center space-y-4 w-full">
              <h2 className="text-4xl font-semibold text-[#101828]">
                {currency}{" "}
                {item.price[billingRate] &&
                  item.price[billingRate][country].toLocaleString()}
              </h2>
              <div className="flex flex-col items-center space-y-1">
                <p className="text-xl font-semibold text-[#101828]">
                  {item.name} plan
                </p>
                <p className="text-base font-normal text-[#667085]">
                  {billingRate} Billed
                </p>
              </div>
            </div>
            {item.name === "Tappi Mini Monthly" && (
              <div className="flex flex-col justify-start items-start space-y-4">
                {benefits.map((benefit) => (
                  <div
                    className="flex flex-row items-start justify-start space-x-3"
                    key={benefit.name}
                  >
                    {benefit.availability ? (
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect width="24" height="24" rx="12" fill="#D1FADF" />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M17.096 7.39016L9.93602 14.3002L8.03602 12.2702C7.68602 11.9402 7.13602 11.9202 6.73602 12.2002C6.34602 12.4902 6.23602 13.0002 6.47602 13.4102L8.72602 17.0702C8.94602 17.4102 9.32601 17.6202 9.75601 17.6202C10.166 17.6202 10.556 17.4102 10.776 17.0702C11.136 16.6002 18.006 8.41016 18.006 8.41016C18.906 7.49016 17.816 6.68016 17.096 7.38016V7.39016Z"
                          fill="#12B76A"
                        />
                      </svg>
                    ) : (
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect width="24" height="24" rx="12" fill="#FEE4E2" />
                        <path
                          d="M16 8L8 16M8 8L16 16"
                          stroke="#D92D20"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    )}
                    <p className="text-base font-normal text-[#667085]">
                      {benefit.name}
                    </p>
                  </div>
                ))}
              </div>
            )}
            <Button
              type="button"
              className="flex items-center justify-center w-full h-12 text-white text-base font-semibold rounded-xl bg-purple-50"
              onClick={() => {
                setPaymentSubscriptionData({
                  subscription_package_id: item.id,
                  subscription_interval: billingRate,
                  amount: item.price[billingRate][country],
                });
                setPaymentReason("SUBSCRIPTION");
                setTopUpAmount(item.price[billingRate][country]);
                selectedPlanHandler(
                  {
                    plan: item.name,
                    rate: billingRate,
                    amount: item.price[billingRate][country],
                  },
                  navigateHandler
                );
              }}
            >
              Continue
            </Button>
          </div>
        ))}
    </div>
  );
}

SubscriptionCards.propTypes = {
  billingRate: PropTypes.string.isRequired,
  navigateHandler: PropTypes.func.isRequired,
};

export default SubscriptionCards;
